import '../../style/index.less';
import './index.less';
// style dependencies
import '../../tooltip/style';



// WEBPACK FOOTER //
// ./components/slider/style/index.tsx